export class AppConfig<T>  {
    load() {
      const jsonFile = 'assets/Config/config.json';
      var response = this.GetSync(jsonFile);
      if (response && response != null) {
          return JSON.parse(response)
        }
        else
          console.log(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
    }
  
  
    public GetSync(url: string): string {
      const xmlHttpRequest = new XMLHttpRequest();
      xmlHttpRequest.open("GET", url, false);
      xmlHttpRequest.overrideMimeType('application/json');
  
      xmlHttpRequest.send();
      if (xmlHttpRequest.status == 200) {
        return xmlHttpRequest.responseText;
      }
      else {
        return null;
      }
    }
  }
  
  